import { useEffect, useState } from "react"
import { eventListeners } from "./eventListener"

// TODO: move to legacy/ui if we relocate eventListeners?

const useIsListening = (key) => {
  const getIsListening = () => !!eventListeners[key]
  const [isListening, setIsListening] = useState(getIsListening)

  // Need to re-check if event key is being listened to if key changes.
  useEffect(() => {
    // Handles updating the current isListening state.
    const hanlder = () => {
      const nextIsListening = getIsListening()
      if (isListening !== nextIsListening) {
        setIsListening(nextIsListening)
      }
    }

    // Call it now.
    hanlder()
    // And then on every subsequent "event-listener" event.
    document.addEventListener("event-listener", hanlder)
    return () => {
      document.removeEventListener("event-listener", hanlder)
    }
  }, [key])

  return isListening
}

export default useIsListening
